import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Trans } from '@lingui/macro';
import styles from './AccountAssociationModal.css';
import gobizLogoUrl from './gobiz-logo.png';
import mokaLogoUrl from './moka-logo.png';
import warningIconUrl from './warning-icon.png';

// API returns 'X' for masking, but UI wants •
function changeMaskingChar(str, from = /X/g, to = '•') {
  return str.replace(from, to);
}

function AccountAssociationModal(props) {
  const { accountAssociation, onClose } = props;
  const { moka, hermes } = accountAssociation;

  return (
    <Modal show>
      <Modal.Header>
        <Modal.Title className={styles.title}>
          <Trans>Your account has been associated with GoBiz</Trans>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          <Trans>
            Moka is part of Gojek family. We are aligning few things to empower
            your business more afterward by associating your Moka and GoBiz
            accounts.
          </Trans>
        </p>

        <div className={styles.infoCardRow}>
          <div className={styles.infoCard}>
            <img src={gobizLogoUrl} alt="GoBiz Logo" />
            <div className={styles.infoCardDetails}>
              <div>
                <Trans>Email: {changeMaskingChar(hermes.email)}</Trans>
              </div>
              <div>
                <Trans>Phone: {changeMaskingChar(hermes.phone)}</Trans>
              </div>
            </div>
          </div>

          <div className={styles.infoCard}>
            <img src={mokaLogoUrl} alt="Moka Logo" />
            <div className={styles.infoCardDetails}>
              <div>
                <Trans>Email: {changeMaskingChar(moka.email)}</Trans>
              </div>
              <div>
                <Trans>Phone: {changeMaskingChar(moka.phone)}</Trans>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Body className={styles.secondBody}>
        <p>
          <strong>
            <span className={styles.warningIcon}>
              <img src={warningIconUrl} />
            </span>{' '}
            <Trans>Please sign in with your GoBiz password</Trans>
          </strong>
        </p>

        <p>
          <Trans>
            We provided a new sign in method. If you sign in with email, you
            should enter your GoBiz password instead of Moka password to sign in
            to your Moka account. If you don’t have one or forget the password,
            you can reset your password.
          </Trans>
        </p>
      </Modal.Body>

      <Modal.Footer className={styles.footer}>
        <button
          type="button"
          className={classNames('btn btn-primary', styles.confirmButton)}
          onClick={onClose}
        >
          <Trans>Agree</Trans>
        </button>
      </Modal.Footer>
    </Modal>
  );
}

AccountAssociationModal.defaultProps = {
  accountAssociation: {},
  onClose: () => {},
};

function mapStateToProps(state) {
  const { accountAssociation } = state.login;

  return {
    accountAssociation,
  };
}

export default connect(mapStateToProps)(AccountAssociationModal);
